import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import history from '~/browserHistory';
import { useUserSelector } from '~/hooks/useUserSelector';
import { fireInviteSent, fireV0RequestSubmitted } from '~/posthogs/events';
import { routes } from '~/routes';
import {
  closeOverlappingModal,
  editJobInfoMdb,
  hideJobCreatePaymentError,
  postInviteToMultiDayJob,
} from '../../../../actions';
import { isDailyOvertime } from '../utils';

export const useConfirmStep = () => {
  const dispatch = useDispatch();
  const [showLeavingPopup, setShowLeavingPopup] = useState(false);
  const navigate = useNavigate();
  const jobInfo = useSelector((state) => state.multiday.jobInfo);
  const job = useSelector((state) => state.job);
  const showJobCreatePaymentError = useSelector((state) => state.job.showJobCreatePaymentError);
  const user = useUserSelector();
  const workerClassificationType = user?.workerClassification?.classificationType;
  const overtimeLimits = user?.overtimeLimits?.[workerClassificationType];
  const hasOvertimeDay = jobInfo.some((job) => isDailyOvertime(job, overtimeLimits?.daily));
  const [showOvertimeLimitPopup, setShowOvertimeLimitPopup] = useState(false);
  const officeId = jobInfo?.[0]?.officeId || user?.id;

  const handleConfirmButton = ({ alertOvertime = true }) => {
    if (alertOvertime && overtimeLimits && hasOvertimeDay) {
      setShowOvertimeLimitPopup(true);
      return;
    }

    // Track PostHog events
    fireV0RequestSubmitted({
      shiftsPosted: jobInfo.length,
      autoconfirmFavorite: jobInfo.some((j) => j.autoFillFavorites) ? 'on' : 'off',
      autoconfirmEligible: jobInfo.some((j) => j.autoFill) ? 'on' : 'off',
      totalInvitesSent: jobInfo[0].professionals?.length ?? 0,
    });

    // Track invite event if professionals are being invited
    if (jobInfo[0].professional?.id) {
      fireInviteSent({
        totalInvitesSent: 1,
        professionalId: jobInfo[0].professional?.id,
        source: 'Shift Request',
      });
    }

    dispatch(postInviteToMultiDayJob(officeId));
  };

  const confirmOverlapping = () => {
    for (let i = 0; i < jobInfo.length; i += 1) {
      const jobData = jobInfo[i];
      dispatch(editJobInfoMdb(jobData.localDate, { ...jobData, duplicate: true }));
    }
    dispatch(closeOverlappingModal());
    handleConfirmButton({ alertOvertime: false });
  };

  const cancelRequest = () => {
    history.push('/');
  };

  const hidePaymentError = () => {
    navigate(-1);
    dispatch(hideJobCreatePaymentError());
  };

  const updatePayment = () => {
    history.push(routes.paymentInformation);
    dispatch(hideJobCreatePaymentError());
  };

  return {
    jobInfo,
    job,
    showLeavingPopup,
    showJobCreatePaymentError,
    setShowLeavingPopup,
    handleConfirmButton,
    confirmOverlapping,
    cancelRequest,
    hidePaymentError,
    updatePayment,
    showOvertimeLimitPopup,
    setShowOvertimeLimitPopup,
  };
};
